import { Injectable } from '@angular/core';
import {MatSnackBar} from '@angular/material';
import {MatDialog} from '@angular/material';
import notify from 'devextreme/ui/notify';
import {ConfirmDialogComponent} from '../component/confirm-dialog/confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class MensagemService {

  constructor(public snackBar: MatSnackBar, public dialog: MatDialog) { }

  public Aviso(msg: string)
  {
    this.snackBar.open(msg, 'Ok', {
      duration: 5000
    });
  }

  public Sucesso(msg: string)
  {
    notify(msg,"success",5000)
  }
  public Error(msg: string)
  {
    notify(msg,"error",5000)
  }

   public ConfirmDialog(titulo: string, msg: string, rt:any): void {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '250px',
          data: {titulo: titulo, msg: msg}
        });
        dialogRef.afterClosed().subscribe(result => rt(result));
      }}
